import _ from 'underscore';
import { mapState } from 'vuex';
import f from '@/application/shared/functions.js'
import JsonViewer from 'vue-json-viewer'
export default {
	name: 'moderation_preivew',
	props: {
		uid : String
	},

	components : {
		JsonViewer
	},

	data : function(){

		return {
			loading : true,
			task : null
		}

	},

	created() {
		
		this.loadData()
	},

	destroyed() {
	},

	watch: {
		
	},
	computed: mapState({
		
		auth : state => state.auth,
		failedGeneration : function(){
			var wf = _.find(this.task.workflow, (wf) => {
				return !this.successGeneration(wf.teamid)
			})

			return wf
		}
		
	}),

	methods : {

		loadData : function(){

			this.loading = true

			this.core.api.moderation.taskdata(this.uid).then((d) => {
				this.task = d

			}).catch(e => {
				this.error = e
			}).finally(() => {
				this.loading = false
			})
		},

		watchStory : function(){
			

			this.core.vueapi.story({
                closeWhenEnd : true,
                composedStory : this.task._story,
                autoplay : true
            }, {
                close : () => {
                }
            })
		},

		watchPodcast : function(){
			

			this.core.vueapi.podcast({
                closeWhenEnd : true,
                composedStory : this.task._podcast,
                autoplay : true,
				podcast : true
            }, {
                close : () => {
                }
            })
		},

		successGeneration : function(teamid){
			if(!this.task.results) return false

			return (this.task.results.completed || []).indexOf(teamid) > -1
		},

		moderationQuestionAccept : function(){
			this.$dialog.confirm(
				this.$t('snippity.moderationQuestionAccept'), {
				okText: this.$t('yes'),
				cancelText : this.$t('no')
			})
	
			.then((dialog) => {
				this.moderationAccept()
			}).catch( e => {
				
			})
		},

		moderationAccept : function(){

			this.promwrapper(this.core.api.moderation.approve(this.uid))

		},
		
		remakeQuestion : function(teamid){
			this.$dialog.confirm(
				this.$t('snippity.moderationQuestion'), {
				okText: this.$t('yes'),
				cancelText : this.$t('no')
			})
	
			.then((dialog) => {
				this.remake(teamid)
			}).catch( e => {
				
			})
		},

		cancelTask: function(){
			this.$dialog.confirm(
				this.$t('snippity.cancelTaskQuestion'), {
				okText: this.$t('yes'),
				cancelText : this.$t('no')
			})
	
			.then((dialog) => {
				
				this.promwrapper(this.core.api.moderation.cancel(this.uid))

			}).catch( e => {
				
			})
		},

		promwrapper : function(promise){
			this.loading = true

			promise.then((d) => {

				this.$store.commit('icon', {
					icon: 'success'
				})
				this.$emit('changed')
				this.$emit('close')

			}).catch(e => {

				this.$store.commit('icon', {
					icon: 'error',
					message: this.$t(e.error || "errors.general")
				})

			}).finally(() => {
				this.loading = false
			})
		},

		remake : function(teamid){

			this.loading = true

			this.promwrapper(this.core.api.moderation.redo(this.uid, teamid))

		}
		
	},
}